import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import App from './App';
const theme = createTheme({

  typography: {
    "fontFamily": 'sans-serif',
    "fontSize": 14,
    "fontWeightLight": 300,
    "fontWeightRegular": 400,
    "fontWeightMedium": 500,

  },
  palette: {
    primary: {
      main: '#434343',
    },
    secondary: {
      main: '#F3F3F3',
    },
    info: {
      main: '#F7C873',
    },
    text:{
      disabled: '#000000',
    },
    error:{
      main: '#dc143c',
    },
    warning:{
      main: '#ff8c00'
    },
    success:{
      main: '#32cd32'
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <React.StrictMode>
    <CssBaseline/>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);


